import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILabRegistration } from '../../models/lab-user-menu/lab-registration';
import { ILabApplication } from '../../models/application-menu/lab-application';
import { environment } from '@env/environment';
import { ILabSampleType } from 'app/models/lab-user-menu/lab-sampleType';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class LabUserMenuService {
  private api: string = environment.privateApi + 'MainMenu/';
  private sampleApi: string = environment.privateApi + 'PhlSampleType/';

  // Mat-table settings
  labFilter: string = '';
  expandedElement: ILabRegistration | null;

  constructor(private http: HttpClient){}

  getUserLabs(): Observable<ILabRegistration[]> {
    return this.http.get<ILabRegistration[]>(this.api + "UserLabs", httpOptions);
  }

  getLabApplications(orelapId: string): Observable<ILabApplication[]> {
    return this.http.get<ILabApplication[]>(this.api + 'LabApplications/' + orelapId);
  }

  getSampleType(orelapId: string): Observable<ILabSampleType[]> {
    return this.http.get<ILabSampleType[]>(this.sampleApi + 'getSampleType/' + orelapId, httpOptions);
  }

  saveSampleType(types: ILabSampleType[]): Observable<void> {
    return this.http.post<void>(this.sampleApi + 'saveSampleType', types ,httpOptions);
  }

  getInspection(appId: number): Observable<ILabRegistration[]> {
    return this.http.get<ILabRegistration[]>(this.api + "getInspection", httpOptions);
  }

}
